import React, { useState } from "react";
import { Table } from "react-bootstrap";
import { FullCalendarType } from "../model/FullCalendarType";
import { MatrixCalendarType } from "../model/MatrixCalendarType";
import Helper from '../utility/helper';
import { CalendarWeekdayHeader } from "./calendarWeekdays";
import { DayDetails } from "./dayDetails";

interface MonthGregoryProps {
    matrixSakawi: MatrixCalendarType[];
    fullSakawi: FullCalendarType[];
    currentGregoryMonth: number;
    currentGregoryYear: number;
    showLatinNumberDate: boolean;
    selectedDate?: Date;
    onSelectDate: (day: FullCalendarType) => void;
}

export const MonthGregory = (props: MonthGregoryProps) => {
    const [datesOfCurrentMonth, setDatesOfCurrentMonth] = useState<FullCalendarType[]>([]);

    React.useEffect(() => {
        function init() {
            // Gregory Date
            const firstGregoryDate = new Date(props.currentGregoryYear, props.currentGregoryMonth, 1);

            // Get date list will be display at current month
            const firstDayOfCurrentGregoryMonthIndex = props.fullSakawi.findIndex(x =>
                x.dateGregory.getDate() === 1
                && x.dateGregory.getMonth() === props.currentGregoryMonth
                && x.dateGregory.getFullYear() === props.currentGregoryYear);
            const firstIndex = firstDayOfCurrentGregoryMonthIndex - firstGregoryDate.getDay();
            const lastIndex = firstIndex + 41; // 42 - 1 cells
            const datesOfCurrentMonth = props.fullSakawi.filter((item, index) => index >= firstIndex && index <= lastIndex);
            setDatesOfCurrentMonth(datesOfCurrentMonth);
        }

        init();
    }, [props.currentGregoryMonth, props.currentGregoryYear, props.fullSakawi]);

    // draw Calendar Table
    let cells: JSX.Element[] = [];
    let rows: JSX.Element[] = [];

    datesOfCurrentMonth.forEach((item, index) => {
        const dayNumbersOfCurrentAhierMonth = Helper.getActualDayNumbersOfAhierMonth(props.matrixSakawi, item.dateAhier.ahierMonth);
        const dayNumbersOfCurrentAwalMonth = Helper.getDayNumbersOfAwalMonth(item.dateAwal.awalMonth.year, item.dateAwal.awalMonth.month);

        cells.push(
            <DayDetails
                sakawiType="sakawiGregory"
                key={`sakawiGregory-cell-${index}`}
                dateAhier={item.dateAhier}
                dateAwal={item.dateAwal}
                dateGregory={item.dateGregory}
                currentGregoryMonth={props.currentGregoryMonth}
                currentGregoryYear={props.currentGregoryYear}
                dayNumbersOfCurrentAhierMonth={dayNumbersOfCurrentAhierMonth}
                dayNumbersOfCurrentAwalMonth={dayNumbersOfCurrentAwalMonth}
                showLatinNumberDate={props.showLatinNumberDate}
                selectedDate={props.selectedDate}
                onSelectDate={() => props.onSelectDate(item)}
            />
        );

        if ((index + 1) % 7 === 0) {
            rows.push(<tr key={`sakawiGregory-row-${index}`}>{cells}</tr>);
            cells = [];
        }
    })

    return (
        <div className="calendar-table-wrap">
            <Table bordered hover className="calendar-table">
                <thead>
                    <tr>
                        <CalendarWeekdayHeader />
                    </tr>
                </thead>
                <tbody>
                    {rows}
                </tbody>
            </Table>
        </div>
    );
}
